<template>
  <CoursesUser :userId="userId" />
</template>

<script>
import CoursesUser from '@/components/home/CoursesUser.vue'

export default {
  name: 'Home',

  components: {
    CoursesUser,
  },

  data() {
    return {
      userId: this.$store.getters.user.id,
    }
  },
}
</script>
